import {
  fetchAndActivate,
  getBoolean,
  getNumber,
  getString,
  getValue,
} from 'firebase/remote-config';
import { firebaseClient } from './client';

export const DEFAULT_VENUE_REGISTRATION_URL = 'https://ottovision33.com.br';

const instance = firebaseClient.remoteConfig;
instance.defaultConfig = {
  isPayWithCreditCardEnabled: false,
  linkOverrideActive: true,
  linkOverrideUrl: DEFAULT_VENUE_REGISTRATION_URL,
};

if (process.env.NODE_ENV !== 'production') {
  instance.settings.minimumFetchIntervalMillis = 5 * 60 * 1000;
}

export const remoteConfig = {
  getBoolean: (key: string) => getBoolean(instance, key),
  getString: (key: string) => getString(instance, key),
  getNumber: (key: string) => getNumber(instance, key),
  getValue: (key: string) => getValue(instance, key),
  fetchAndActivate: () => fetchAndActivate(instance),
};

export const remoteConfigReady = remoteConfig.fetchAndActivate().catch(() => false);
